var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"id":"app","element-loading-background":"rgba(255, 255, 255, 0.96)"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }